module.exports = __webpack_public_path__ + "img/couples-088.40a37a91.jpg";